module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/File-done-8873931aa16e275744f07d7e444b9f76.svg";